import { axios } from '@Root/API'

export const edit = snapshotId => {
	return axios.get(`snapshots/${snapshotId}`)
}
